import { useMemo } from 'react';
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import QCXAutocompleteSelect from '../../autocomplete-select/QCXAutocompleteSelect';
import type { AtributoCampoProps } from './types';

type SelectOption = {
  id: string;
  value: string;
};

export default function ListaEstaticaV2({ atributo, basePath, disabled = false }: AtributoCampoProps) {
  const name = `${basePath}.${atributo.codigo}.valor`;
  const label = `${atributo.descricaoCodigo} (${atributo.codigo})`;
  const filterOptions = createFilterOptions<SelectOption>({ stringify: (item) => `${item.id} - ${item.value}` });
  const options = useMemo(
    () =>
      atributo.dominio.map((opcao): SelectOption => ({
        id: opcao.valor,
        value: opcao.descricao,
      })),
    [atributo.dominio]
  );

  return (
    <QCXAutocompleteSelect
      label={label}
      id={name}
      name={name}
      options={options}
      filterOptions={filterOptions}
      getOptionLabel={(item: SelectOption) => (item.value ? `${item.id} - ${item.value}` : '')}
      required
      disabled={disabled}
      isConsult={disabled}
    />
  );
}
